import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  AFFILIATE_CREATIVES_LINK_FORM_ROUTE_NAME,
  AFFILIATE_CREATIVES_LINK_ROUTE_NAME,
  CREATIVES_LINK_PERMISSIONS,
  TRANSLATION_GROUP_CREATIVES_LINK,
} from '@modules/creatives-link/constants';
import { CreativesLinkTableModule } from '@modules/creatives-link/submodules/CreativesLinkTableModule';
import getTranslationKeys from '@modules/creatives-link/translations';
import { useI18n } from '@modules/i18n/composables';
import {
  AFFILIATE_TRACKING_LINKS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class CreativesLinkModule extends AppModule {
  protected submodules = [
    new CreativesLinkTableModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_CREATIVES_LINK_ROUTE_NAME,
      path: 'creatives-link',
      permission: CREATIVES_LINK_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'CreativesLinkPage',
      redirect: { name: AFFILIATE_CREATIVES_LINK_FORM_ROUTE_NAME },
    });

    router.addChildRoute(AFFILIATE_CREATIVES_LINK_ROUTE_NAME, {
      name: AFFILIATE_CREATIVES_LINK_FORM_ROUTE_NAME,
      path: '',
      component: () => import('@modules/creatives-link/pages/CreativesLinkPage/CreativesLinkPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_TRACKING_LINKS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_GET_CREATIVES_LINK'),
      to: {
        name: AFFILIATE_CREATIVES_LINK_ROUTE_NAME,
      },
      permission: CREATIVES_LINK_PERMISSIONS.SHOW,
      id: AFFILIATE_CREATIVES_LINK_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_CREATIVES_LINK, getTranslationKeys);
  }
}
